export default __webpack_public_path__ + "static/media/item-img.ca596ca5.svg";